import { Injectable } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster';
import * as firebase from 'firebase';

import 'style-loader!angular2-toaster/toaster.css';
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from '@nebular/theme';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommanService {

  constructor(private toastrService: NbToastrService,private http: HttpClient, ) { }
  showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? ` ${title}` : '';

    this.toastrService.show(
      body,
      `${titleContent}`,
      config);
  }

  getCurrentDate() {
    return firebase.firestore.Timestamp.now();
  }
  getStateName(): Observable<any> {

    return this.http.get('assets/indianStates.json').pipe(map(res => res));
}
}
